export function getDynamicIslandDataFromState() {
  const {
    designSystem,
    state,
    components,
    snippets,
    pages,
    functions,
    methods,
    files,
    dependencies
  } = this.getData()

  return {
    designSystem,
    state,
    components,
    snippets,
    pages,
    functions,
    methods,
    files,
    dependencies
  }
}

export function getActiveDynamicIslandCategory() {
  return this.getFilesSidebar()?.state?.activeFileSidebar || 'Local'
}

export function getSidebarContent() {
  return this.getFilesSidebar()?.state?.activeContent
}

export async function setSidebarContent(activeContent) {
  if (this.isEmbed()) return
  await this.getFilesSidebar()?.state.update({ activeContent })
  this.call('setCookie', this.getAppKey() + '_activeContent', activeContent)
  return activeContent
}

export function getActiveSidebarTypes(
  contentKey = this.call('getSidebarContent')
) {
  return this.call('getTypes', contentKey)
}

export function isTypeSidebarActive(type) {
  return this.call('getActiveSidebarTypes').includes(type)
}

export function setActiveDynamicIslandCategory(category) {
  this.getFilesSidebar().state.update({ activeFileSidebar: category })
}

// TODO: check if its calling is using await
export async function getDynamicIslandDataByCategory(activeFileSidebar) {
  if (!activeFileSidebar) return
  const category = activeFileSidebar.toLowerCase()
  if (category === 'local') {
    return this.call('getDynamicIslandDataFromState')
  } else if (category === 'builtins') {
    return {} // BUILTINS_LIBRARY
  } else if (category === 'shared libraries') {
    return await this.getDefaultDesignSystem()
  }
}

export function toggleRenameInput(type, key) {
  const listEl = this.getDynamicIsland().lookdown(
    (el, s) => s.key === key && s.type === type
  )

  if (!listEl) return

  listEl.state.update({ editing: true })
  const t = setTimeout(() => {
    listEl.Rename.Label.Input.node.select()
    clearTimeout(t)
  }, 0)
}

export function findFileSidebarSection(type) {
  const sidebar = this.getFilesSidebar()
  if (!sidebar || typeof sidebar.lookdown !== 'function') {
    return
  }
  return sidebar.lookdown((el, s) => el.FilesSidebarList && s.type === type)
}

export function findFileSidebarItem(type, key) {
  const section = this.call('findFileSidebarSection', type)
  if (!section) {
    return
  }
  return section.lookdown((el, s) => el.Rename && s.key === key)
}

export async function rerenderFileSidebarByType(type, opts) {
  if (!this.getFilesSidebar()) {
    return
  }
  const section = this.call('findFileSidebarSection', type)
  if (!section) {
    return
  }

  return await section.update({}, opts)
}
